import {
    wsFrLang,
    authFrLang,
    coreFrLang,
    commonFrLang,
    wsEnLang,
    authEnLang,
    coreEnLang,
    commonEnLang
} from '@ft/core';

import {visualizerFrLang, visualizerEnLang} from '@ft/file-manager';
import {officeSettingsFrLang, officeSettingsEnLang, officeFrLang, officeEnLang, } from '@ft/office';

// french
import {lang as explorerFr} from './explorer/i18n/fr';
import {lang as settingsFr} from './settings/i18n/fr';
import {lang as viewerFr} from './viewer/i18n/fr';
import {lang as authenticationFr} from './authentication/i18n/fr';

// english
import {lang as viewerEn} from './viewer/i18n/en';
import {lang as explorerEn} from './explorer/i18n/en';
import {lang as settingsEn} from './settings/i18n/en';
import {lang as authenticationEn} from './authentication/i18n/en';

const fr = Object.assign(
    {},
    {ws: wsFrLang},
    {auth: authFrLang},
    {core: coreFrLang},
    {common: commonFrLang},
    {explorer: explorerFr},
    {settings: settingsFr},
    {office: officeFrLang},
    {office_settings: officeSettingsFrLang},
    {authentication: authenticationFr},
    {viewer: Object.assign({}, viewerFr, visualizerFrLang)},
    {
        shared: {
            dcm_upload: 'Upload',
            archives: 'Archives',
            explorer: 'Explorateur',
            reports: 'Comptes Rendus',
            copyright: 'Licence accordée à <strong class=\'client\'>{{client}}</strong> jusqu\'a <strong class=\'validity\'>{{validUntil}}</strong></span> - <span>2016-{{currentYear}} &copy; - dépôt légal N°2017LB0009'
        }
    },
);


const en = Object.assign(
    {},
    {ws: wsEnLang},
    {auth: authEnLang},
    {core: coreEnLang},
    {common: commonEnLang},
    {explorer: explorerEn},
    {settings: settingsEn},
    {office: officeEnLang},
    {office_settings: officeSettingsEnLang},
    {authentication: authenticationEn},
    {viewer: Object.assign({}, viewerEn, visualizerEnLang)},
    {
        shared: {
            dcm_upload: 'Upload',
            archives: 'Archives',
            explorer: 'Explorer',
            reports: 'Reports',
            copyright: 'License granted to <strong class=\'client\'>{{client}}</strong> until <strong class=\'validity\'>{{validUntil}}</strong></span> - <span>2013-{{currentYear}} &copy; - Legal Deposit N°2017LB0009',
        }
    },
);

export const lang = {
    fr, en
};
